import { EquipmentAttribute, SimulationModal, getSimManualInputs, saveManualInput } from "@/services/project/simulation.service"
import { VariableTable } from "../VariableTable/VariableTable"
import { useRequest } from "ahooks"
import { Space, Button, Tooltip } from "antd"
import { useEffect, useState } from "react"
import { IconFont } from "@/components/IconFont"
import classNames from "classnames"
import styles from './styles.module.less'
import {cloneDeep} from 'lodash-es'
import { UnitStates } from "@/components/FlowSheetEditor/components/UnitSelect/UnitSelect"
import { useGetDisplayValue } from "../useGetDisplayValue"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"

interface ManualInputProps {
  units: UnitStates
  simulation: SimulationModal
}
export const ManualInputs = (props: ManualInputProps) => {
  const {units, simulation} = props
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const {data = []} = useRequest(() => getSimManualInputs({sId: simulation.id}))
  const [value, setValue] = useState(data)
  const getDisplayValue = useGetDisplayValue()

  const fromDefaultVal = (values: EquipmentAttribute[]) => {
    if (values && values.length > 0) {
      values.forEach(item => {
        item.displayValue = getDisplayValue(units, item)
      })
    }

    return values;
  }

  useEffect(() => {
    const cloneData = cloneDeep(data) || [];
    setValue(fromDefaultVal(cloneData))
  }, [data])

  const removeDisplayAttrs = (values: EquipmentAttribute[]) => {
    if (values && values.length > 0) {
      values.forEach(item => {
        delete item.displayValue
      })
    }
    return values;
  }

  const save = () => {
    if (flowSimulation?.id) {
      saveManualInput({dvars: removeDisplayAttrs(value)}, {sId: flowSimulation?.id})
    }
  }

  return <div className={styles.container}>
    <Space className="flex-end">
      <Tooltip title="Upload to server">
        <Button icon={<IconFont type="icon-cloud-upload" />} onClick={save} />
      </Tooltip>
    </Space>
    <div className={classNames('mt-1', styles.content)}>
      <VariableTable value={value} units={units} hasCreate={false} onChange={(val) => setValue(val)} />
    </div>
  </div>
}